export default "__VITE_ASSET__DMVnIdL___"